import styled from 'styled-components';

export const Container = styled.div`
  @import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
  font-family: 'Poppins', sans-serif !important;
  font-weight: 400 !important;
  font-style: normal !important;

  .img-banner {
    max-height: 75px;
  }

  span {
    color: #dbed4a;
  }

  .btn {
    border: 2px solid ${(props) => props.theme.$white};
    background: rgba(255, 255, 255, 0.1);
    color: ${(props) => props.theme.$white};
    margin-left: 20px;
    text-shadow: none;
  }

  .btn:hover {
    color: ${(props) => props.theme.$renewal_color};
    background: ${(props) => props.theme.$white};
  }
`;
